import { Link } from 'react-router'
import { Button } from '@/components/Button'

/*
 * Board vocabulary: a code, one line, a way back. A 404 is a departure that was
 * never scheduled, so it gets the smallest possible plate.
 */
export function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[60dvh] max-w-md flex-col items-center justify-center gap-5 px-4 text-center">
      <p className="flap rounded-[3px] px-3 py-1.5 font-mono text-[11px] tracking-[0.14em] text-muted">
        404
      </p>
      <h1 className="signage text-lg text-ink sm:text-xl">No board for that address</h1>
      <Link to="/">
        <Button variant="primary">Back to the board</Button>
      </Link>
    </div>
  )
}
